const FALLBACK_TIME_ZONES = [
  "UTC",
  "Africa/Cairo",
  "Africa/Johannesburg",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/New_York",
  "America/Sao_Paulo",
  "Asia/Dubai",
  "Asia/Hong_Kong",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Tokyo",
  "Australia/Sydney",
  "Europe/Berlin",
  "Europe/London",
  "Europe/Paris",
];

const TIME_ZONE_ALIASES = {
  "Asia/Calcutta": "Asia/Kolkata",
};

export const normalizeTimeZoneName = (timeZone) =>
  TIME_ZONE_ALIASES[timeZone] || timeZone;

export const getLocalTimeZone = () =>
  normalizeTimeZoneName(Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC");

export const getTimeZoneOptions = () => {
  const supportedTimeZones =
    typeof Intl.supportedValuesOf === "function"
      ? Intl.supportedValuesOf("timeZone")
      : FALLBACK_TIME_ZONES;
  const localTimeZone = getLocalTimeZone();
  const timeZones = Array.from(
    new Set([localTimeZone, "UTC", ...supportedTimeZones.map(normalizeTimeZoneName)])
  ).sort((first, second) => first.localeCompare(second));

  return timeZones.map((timeZone) => ({
    value: timeZone,
    label: timeZone,
  }));
};
